import { render } from "./GoalHistoryModal.vue?vue&type=template&id=5c9a689c&scoped=true"
import script from "./GoalHistoryModal.vue?vue&type=script&lang=js"
export * from "./GoalHistoryModal.vue?vue&type=script&lang=js"

import "./GoalHistoryModal.vue?vue&type=style&index=0&id=5c9a689c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9a689c"]])

export default __exports__